import Vue from 'vue'
import Router from 'vue-router'

// Containers
//const TheContainer = () => import('@/containers/TheContainer')

const AsignacionEmpresas = () => import('@/views/administracion/AsignacionEmpresas')
const AsignacionPerfiles = () => import('@/views/administracion/AsignacionPerfiles')
const UsuariosCrud = () => import('@/views/administracion/UsuariosCrud')
const AdministracionUsuarios = () => import('@/views/administracion/AdministracionUsuarios')


const Documentos = () => import('@/views/remuneraciones/RevisionDocumentos')
const PortalCliente = () => import('@/views/administracion/PortalCliente')

const Contratos = () => import('@/views/importaciones/remuneraciones/Contratos')

// Views - Pages
const Login = () => import('@/views/pages/Login')

const CambioPass = () => import('@/views/pages/CambioContrasenia')


const TheContainerAdmin = () => import('@/vappAdminContainer/TheContainerAdmin')
const LoginAdmin = () => import('@/views/AdminGesto/LoginAdmin')
const ClientesAdmin = () => import('@/views/AdminGesto/ClientesAdmin')
const ConfiguracionCliente = () => import('@/views/AdminGesto/ConfiguracionCliente')
//const UploadFile = () => import('@/views/AdminGesto/UploadFile')
//const SimpleUploadFile = () => import('@/views/AdminGesto/SimpleUpload')

const ClientesB2B = () => import('@/views/clientesB2B/ClientesB2B')
//const ClientesVappEdig = () => import('@/views/vappAdmin/ClientesVappEdig')
const logsAdmin = () => import('@/views/AdminGesto/LogsView')

const GestoMain = () => import('@/views/gesto/GestoMain')


const productos = () => import('@/views/AdminGesto/PruebaProductos')



import cons from '@/const'

Vue.use(Router)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes() {
  return [
    {
      path: '/',
      redirect: '/login/loginAdmin',
      name: 'HomeAdmin',
      component: TheContainerAdmin,
      children: [
        {
          path: 'administracion',
          name: 'Administracion',
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: 'gestoAdmin',
              name: 'Gesto Admin',
              component: GestoMain
            },
            {
              path: 'clientes',
              name: 'Clientes',
              component: ClientesAdmin
            },
            {
              path: 'configCliente',
              name: 'ConfiguracionCliente',
              component: ConfiguracionCliente
            },
            {
              path: 'clientesB2B',
              name: 'ClientesB2B',
              component: ClientesB2B
            },
            {
              path: 'logsAdmin',
              name: 'logsAdmin',
              component: logsAdmin
            },
          ]
        },
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'loginAdmin',
          name: 'LoginAdmin',
          component: LoginAdmin
        },
      ]
    },
    {
      path: '/prod',
      name: 'Prod',
      component: {
        render(c) { return c('router-view') }
      },
      children: [
        {
          path: 'productos',
          name: 'Productos',
          component: productos
        },
      ]
    },
    /*{
      path: '/',
      redirect: '/admin/administracion/clientes',
      name: 'Home',
      component: TheContainer,
      children: [
        {
          path: 'remuneraciones',
          //redirect: cons.rutaRedireccion, 
          name: 'Remuneraciones',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'documentos',
              name: 'Documentos',
              component: Documentos
            },
            {
              path: 'portal_cliente',
              name: 'Portal Clientes',
              component: PortalCliente
            },
          ]
        },
        {
          path: 'administracion',
          redirect: '/administracion/administracion_usuarios',
          name: 'Administración',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'asignar_empresas',
              name: 'Asignar Empresas',
              component: AsignacionEmpresas
            },
            {
              path: 'asignar_perfiles',
              name: 'Asignar Perfiles',
              component: AsignacionPerfiles
            },
            {
              path: 'config_usuarios',
              name: 'Mis Usuarios',
              component: UsuariosCrud
            },
            {
              path: 'administracion_usuarios',
              name: 'Administrar Usuarios',
              component: AdministracionUsuarios
            },
          ]
        },
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'cambioPass',
          name: 'CambioPass',
          component: CambioPass
        },
      ]
    },
    {
      path: '/vapp',
      name: 'Vapp',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: 'loginAdmin',
          name: 'LoginAdmin',
          component: LoginAdmin
        },
      ]
    },*/
  ]
}

